import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class StepGuideService {

  url = environment.serverAPI4 + "/api/stepGuide";

  constructor(private http: HttpClient) { }

  getAllStepGuide(Page: any, size: any, sort: any): Observable<Object> {
    return this.http.get(`${this.url}?page=${Page}&size=${size}&sort=${sort}`);
  }
  getAllStepGuideDropDown(): Observable<Object> {
    return this.http.get(`${this.url}/dropdown`);
  }

  getStepGuideById(id: number): Observable<Object> {
    return this.http.get(`${this.url}/${id}`);
  }

  addOrEditStepGuide(StepGuide: any): Observable<Response[]> {
    return this.http.post<Response[]>(`${this.url}`, StepGuide);
  }

  StepGuideSearch(query, Page: any, size: any, sort: any): Observable<Object> {
    return this.http.get(`${this.url}/filter?search=${query}&page=${Page}&size=${size}&sort=${sort}`);
  }
  deleteByStepGuideId(id: any): Observable<Object> {
    return this.http.delete(`${this.url}/${id}`);
  }

  getPlansAndDeviceType(module, deviceTypeLong) {

    if (window.innerWidth <= 768 && deviceTypeLong == 1) {

      deviceTypeLong = 2;

    }


    return this.http.get(`${this.url}/by/${module}/${deviceTypeLong}`);
  }


}
